import type { State } from '../../typings'
import type { ActivityType } from '../../../typings'

export const createActivityTypeProducer = (
  state: State,
  payload?: ActivityType,
) => ({
  ...state,
  isOpen: false,
  current: undefined,
  activityTypes: payload
    ? [...state.activityTypes, payload]
    : [...state.activityTypes],
})
